import { string, object } from "yup";
import { ENGLISH_CHARS } from "@pepdirect/ui/validation";

const FIELD_REQUIRED = "This field cannot be left blank";
const WRONG_EMAIL = "Email address is not valid";

const FIELD_SELECT_SHAPE = {
  value: string(),
  label: string(),
};

export const getStartedSchema = object({
  firstName: string().required(FIELD_REQUIRED).nullable(),
  lastName: string().required(FIELD_REQUIRED).nullable(),
  emailField: string()
    .trim()
    .email(WRONG_EMAIL)
    .matches(ENGLISH_CHARS, {
      excludeEmptyString: true,
      message: WRONG_EMAIL,
    })
    .required(FIELD_REQUIRED),
  businessName: string().required(FIELD_REQUIRED).nullable(),
  phoneNumber: string().required(FIELD_REQUIRED).nullable(),
  businessAddress: string().required(FIELD_REQUIRED).nullable(),
  city: string().required(FIELD_REQUIRED).nullable(),
  state: object().shape(FIELD_SELECT_SHAPE).required(FIELD_REQUIRED).nullable(),
  zip: string().required(FIELD_REQUIRED).nullable(),
  businessType: object()
    .shape(FIELD_SELECT_SHAPE)
    .required(FIELD_REQUIRED)
    .nullable(),
  numberOfUsers: object()
    .shape(FIELD_SELECT_SHAPE)
    .required(FIELD_REQUIRED)
    .nullable(),
  manageAndOrder: object()
    .shape(FIELD_SELECT_SHAPE)
    .required(FIELD_REQUIRED)
    .nullable(),
});
